import React from 'react';

const tickIcon = () => (
    <svg viewBox="0 0 60 46.208">
        <polygon points="0,22.377 0.001,22.377 10.012,12.366 23.831,26.186 49.927,0 60,10.073 23.83,46.208 
		0,22.377 "/>
    </svg>
)

export default tickIcon;